<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import Swal from 'sweetalert2';

  import {StreamService} from '@/services';
  import * as Store from '@/store';

  import Dialog from '../../../components/dialog/Dialog.svelte';
  import LanguagePicker from '../LanguagePicker.svelte';
  import {v4} from 'uuid';
  import appConfig from '@/config';
  export let isUploadLiveStreamDialogOpen = false;

  let isLoadingStream = true;

  let streamServer = appConfig.streamUrl;
  let streamKey = '';
  let selectedLanguage = '';

  const streamService = new StreamService();
  const languageSubscription = Store.language.subscribe(value => (selectedLanguage = value));

  function getUserStream() {
    streamService
      .getStreamInformation()
      .then(async response => {
        if (
          typeof response === 'object' &&
          response.streamName &&
          typeof response.streamName === 'string' &&
          response.streamName !== ''
        ) {
          streamKey = response.streamName;
          isLoadingStream = false;
          return;
        }

        streamService
          .createStreamInformation({streamName: v4()})
          .then(() => {
            Swal.fire({
              position: 'bottom-end',
              icon: 'success',
              title: 'Stream Added',
              showConfirmButton: false,
              timer: 1500,
              toast: true
            });
            getUserStream();
          })
          .catch(error => {
            console.error('Failed to create stream information', error);
            Swal.fire({
              position: 'bottom-end',
              icon: 'error',
              title: 'Failed to create stream information',
              showConfirmButton: false,
              timer: 1500,
              toast: true
            });
            isLoadingStream = false;
          });
      })
      .catch(error => {
        console.error('failed to retrieve stream information', error);
        Swal.fire({
          position: 'bottom-end',
          icon: 'error',
          title: 'Failed to retrieve stream information',
          showConfirmButton: false,
          timer: 1500,
          toast: true
        });
        isLoadingStream = false;
      });
  }

  function copy2Clipboard(text: string, options: {successMessage?: string; errorMessage?: string} = {}) {
    if (typeof options !== 'object') options = {};

    if (!navigator || !navigator.clipboard)
      return Swal.fire({
        position: 'bottom-end',
        icon: 'error',
        title: 'Browser does not support Clipboard',
        showConfirmButton: false,
        timer: 1500,
        toast: true
      });

    navigator.clipboard
      .writeText(text)
      .then(() => {
        Swal.fire({
          position: 'bottom-end',
          icon: 'success',
          title: options.successMessage || 'text copied to Clipboard',
          showConfirmButton: false,
          timer: 1500,
          toast: true
        });
      })
      .catch(error => {
        console.error('Failed to Copy URL to Clipboard', error);
        Swal.fire({
          position: 'bottom-end',
          icon: 'error',
          title: options.errorMessage || 'Failed to text to clipboard',
          showConfirmButton: false,
          timer: 1500,
          toast: true
        });
      });
  }

  onMount(() => {
    getUserStream();
  });
  onDestroy(() => {
    languageSubscription();
  });
</script>

<Dialog bind:isDialogOpen={isUploadLiveStreamDialogOpen} useIfShow={true}>
  <div class="pointer-events-none flex h-full w-full items-end justify-center lg:items-center">
    <div
      class="pointer-events-auto h-auto w-full min-w-[280px] rounded-t-2xl border border-gray-500 bg-white p-12 shadow-lg dark:border-zinc-600 dark:bg-zinc-700 lg:max-w-[680px] lg:rounded-3xl"
    >
      <div class="flex items-center pb-2">
        <div class="grid text-black dark:text-zinc-200">
          <div class="flex items-center gap-2 py-1.5">
            <h1 class="text-lg font-bold">Upload Livestream</h1>
          </div>
          <p class="text-sm text-black dark:text-zinc-300">
            Your credits will be deducted based on the total length of your live stream.
          </p>
          <a
            href="https://support.sermonshots.com/en/knowledgebase/article/how-to-upload-videos-to-sermon-shots-via-live-stream"
            target="_blank"
            class="py-2 text-sm text-primary underline dark:text-primary-500"
            >How to upload Videos to Sermon Shots via Live Stream</a
          >
        </div>
        <button
          on:click={() => (isUploadLiveStreamDialogOpen = false)}
          class="ml-auto rounded-full px-2 hover:bg-zinc-100"
        >
          <i class="fa-solid fa-xmark p-2 text-lg text-black" aria-hidden="true"></i>
        </button>
      </div>
      <!-- <hr class="border-t border-t-gray-300 dark:border-zinc-600"> -->
      <div class="grid pt-6">
        <div class="py-2">
          <label for="stream-server" class="block text-sm font-medium text-gray-800 dark:text-zinc-200"
            >Streaming Server</label
          >
          <div class="flex pt-2">
            <input
              bind:value={streamServer}
              id="stream-server"
              type="text"
              placeholder="rtmp://stream.sermonshots.com/live"
              class="block w-full rounded-bl-lg rounded-tl-lg border border-y border-gray-300 bg-white px-4 py-2.5 text-gray-800 placeholder-gray-500 focus:border-primary focus:outline-none focus:ring focus:ring-primary focus:ring-opacity-40 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200 dark:placeholder-zinc-500 dark:focus:border-blue-300"
              readonly
            />
            <button
              on:click={() =>
                copy2Clipboard(`${streamServer}`, {
                  successMessage: 'Stream server url copied to clipboard',
                  errorMessage: 'Failed to copy stream server url to clipboard'
                })}
              class="flex items-center gap-2 rounded-br-lg rounded-tr-lg border-y border-r border-gray-300 bg-white px-4 text-sm font-bold text-gray-800 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200"
            >
              <i class="fa-solid fa-copy"></i>
              <span>Copy</span>
            </button>
          </div>
        </div>
        <div class="py-2">
          <label for="stream-key" class="block text-sm font-medium text-gray-800 dark:text-zinc-200">Stream Key</label>
          <div class="flex pt-2">
            <input
              bind:value={streamKey}
              id="stream-key"
              type="text"
              placeholder="10c64856-e183-4799-98e4-a1d9f16acd10"
              class="block w-full rounded-bl-lg rounded-tl-lg border border-y border-gray-300 bg-white px-4 py-2.5 text-gray-800 placeholder-gray-500 focus:border-primary focus:outline-none focus:ring focus:ring-primary focus:ring-opacity-40 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200 dark:placeholder-zinc-500 dark:focus:border-blue-300"
              readonly
            />
            <button
              on:click={() =>
                copy2Clipboard(`${streamKey}`, {
                  successMessage: 'Stream key copied to clipboard',
                  errorMessage: 'Failed to copy stream key to clipboard'
                })}
              class="flex items-center gap-2 rounded-br-lg rounded-tr-lg border-y border-r border-gray-300 bg-white px-4 text-sm font-bold text-gray-800 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200"
            >
              <i class="fa-solid fa-copy"></i>
              <span>Copy</span>
            </button>
          </div>
        </div>
        <div class="py-2">
          <label for="username" class="block text-sm font-medium text-gray-800 dark:text-zinc-200">Others</label>
          <div class="flex pt-2">
            <button
              class="flex w-full items-center rounded-lg border border-gray-300 bg-gray-50 p-2 text-gray-800 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200"
            >
              <p class="px-2 text-sm font-medium">Copy Full Stream URL</p>
              <button
                on:click={() =>
                  copy2Clipboard(`${streamServer}/${streamKey}`, {
                    successMessage: 'Stream URL copied to clipboard',
                    errorMessage: 'Failed to copy stream url to clipboard'
                  })}
                class="ml-auto flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-1.5 text-sm font-bold text-gray-800 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-200"
              >
                <i class="fa-solid fa-copy"></i>
                <span>Copy</span>
              </button>
            </button>
          </div>
        </div>
      </div>
      <!-- <hr class="border-t border-t-gray-300 dark:border-zinc-600"> -->
      <div class="flex justify-end gap-2 pt-6">
        <button
          on:click={() => (isUploadLiveStreamDialogOpen = false)}
          class="flex items-center rounded-md bg-primary px-3 py-2 font-medium text-white hover:bg-primary-600"
        >
          <span>Close</span>
        </button>
      </div>
    </div>
  </div>
</Dialog>
